import clsx from "clsx";
import React from "react";

const HorizontalRule = () => {
  return <hr className={clsx("border-t h-0")} />;
};

export default HorizontalRule;
